var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-checkbox',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"hide-details":""},model:{value:(_vm.property),callback:function ($$v) {_vm.property=$$v},expression:"property"}})
}
var staticRenderFns = []

export { render, staticRenderFns }